import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgErrorPageBgImage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 946,
	height: 329,
	viewBox: "0 0 946 329",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 789.682,
			cy: 222.682,
			r: 28.6821,
			fill: "#E46969"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 329C0 240.621 71.6475 169 160 169H320V329H0Z",
			fill: "#002266"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M817.529 290.019C767.534 340.014 686.489 339.999 636.51 290.019L546 199.51L636.51 109L817.529 290.019Z",
			fill: "#105ED5"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 176,
			cy: 139,
			r: 30,
			fill: "#A2A3AD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M310.411 3.57123e-05L269 154.548L423.548 195.959C446.415 110.617 395.779 22.8743 310.411 3.57123e-05Z",
			fill: "#FFB066"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M390.237 186.527L319.527 257.237L390.237 327.948C429.284 288.901 429.296 225.585 390.237 186.527Z",
			fill: "#105ED5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M568.421 176.711L497.711 106L427 176.711C466.047 215.757 529.363 215.769 568.421 176.711Z",
			fill: "#E46969"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M418 329L546 329L546 201C475.318 201 418 258.296 418 329Z",
			fill: "#FFB066"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M818 201L818 329L946 329C946 258.318 888.704 201 818 201Z",
			fill: "#002266"
		})
	]
});
export { SvgErrorPageBgImage as ReactComponent };
